import { put, take, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export function* watchForTopicUpdateError() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.TOPIC_UPDATE_ERROR);
    const updates = {
      interestedIn: !action.updates.interestedIn
    };
    yield put(actions.topicUpdateRevert(action.id, updates));
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.TOPICS_FETCH, request(api.topicsFetch, 'topicsType', 'categoryId')),
    fork(takeLatest, actions.TOPIC_UPDATE, request(api.topicUpdate, 'id', 'updates')),
    fork(watchForTopicUpdateError)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/sagas.js
 **/